<template>
  <v-dialog v-model="show" max-width="400">
    <v-card>
      <v-card-title>
        {{
          selectedParkingFineReportingTask
            ? $vuetify.lang.t('$vuetify.ENFORCEMENT.PARKING_FINE_REPORTS.EDIT')
            : $vuetify.lang.t(
                '$vuetify.ENFORCEMENT.PARKING_FINE_REPORTS.ADD_NEW'
              )
        }}
      </v-card-title>
      <v-form ref="form" v-model="formValid">
        <v-card-text>
          <v-select
            v-model="selectedVehicleGroup"
            :items="vehicleGroupsWithNewGroupOption"
            :loading="loading.state && loading.type === 'getAllVehicleGroups'"
            return-object
            item-text="name"
            clearable
            label="Vali autogrupp(Kui ei vali, tuleb alla sisestada uue grupi nimi)"
            :disabled="
              selectedParkingFineReportingTask &&
                selectedParkingFineReportingTask.ID > 0
            "
            class="mb-3"
          />
          <v-text-field
            v-if="
              (selectedVehicleGroup &&
                selectedVehicleGroup.name === 'UUS_GRUPP/NEW_GROUP') ||
                !selectedVehicleGroup
            "
            v-model="newVehicleGroupName"
            :label="
              $vuetify.lang.t(
                '$vuetify.ENFORCEMENT.PARKING_FINE_REPORTS.NEW_VEHICLE_GROUP_NAME'
              )
            "
            placeholder="ETTEVÕTE OÜ"
            :required="
              (selectedVehicleGroup &&
                selectedVehicleGroup.name == 'UUS_GRUPP/NEW_GROUP') ||
                !selectedVehicleGroup
            "
            :rules="newVehicleGroupNameRules"
            class="mb-3"
          />
          <v-text-field
            v-model="emailTo"
            :label="
              $vuetify.lang.t(
                '$vuetify.ENFORCEMENT.PARKING_FINE_REPORTS.EMAIL_TO'
              )
            "
            placeholder="email@example.com,email2@example.com"
            required
            :rules="emailToRules"
            class="mb-3"
          />
          <v-text-field
            v-model="emailBcc"
            :label="
              $vuetify.lang.t(
                '$vuetify.ENFORCEMENT.PARKING_FINE_REPORTS.EMAIL_BCC'
              )
            "
            placeholder="email@example.com,email2@example.com"
            class="mb-3"
          />
          <v-text-field
            v-model="sendingDays"
            :label="
              $vuetify.lang.t(
                '$vuetify.ENFORCEMENT.PARKING_FINE_REPORTS.SENDING_DAYS'
              )
            "
            placeholder="2, 7"
            class="mb-3"
          />
          <v-checkbox
            v-model="isMonthlyReportingEnabled"
            :label="
              $vuetify.lang.t(
                '$vuetify.ENFORCEMENT.PARKING_FINE_REPORTS.IS_MONTHLY_REPORTING_ENABLED'
              )
            "
            hide-details
            color="success"
            class="ma-0 mb-5"
          ></v-checkbox>
        </v-card-text>
      </v-form>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="show = false">
          {{ $vuetify.lang.t('$vuetify.CLOSE') }}
        </v-btn>
        <v-btn color="primary" class="secondary--text" @click="onSave()">
          {{ $vuetify.lang.t('$vuetify.SAVE') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'

export default {
  name: 'ParkingFineReportingTaskDialog',
  props: {
    visible: {
      type: Boolean,
      required: true,
      default: false
    }
  },
  data() {
    return {
      formValid: false,
      selectedVehicleGroup: undefined,
      newVehicleGroupName: undefined,
      newVehicleGroupNameRules: [
        v =>
          (this.selectedVehicleGroup &&
            this.selectedVehicleGroup.name === 'UUS_GRUPP/NEW_GROUP') ||
          !this.selectedVehicleGroup
            ? !!v ||
              this.$vuetify.lang.t(
                '$vuetify.ENFORCEMENT.PARKING_FINE_REPORTS.NEW_VEHICLE_GROUP_NAME_IS_REQUIRED'
              )
            : true
      ],
      emailTo: '',
      emailToRules: [
        v => !!v || this.$vuetify.lang.t('$vuetify.EMAIL_IS_REQUIRED')
      ],
      emailBcc: '',
      sendingDays: '2, 7',
      isMonthlyReportingEnabled: true,
      error: undefined
    }
  },
  computed: {
    ...mapGetters('app', ['loading']),
    ...mapGetters('enforcement', ['selectedParkingFineReportingTask']),
    ...mapGetters('vehicleGroups', ['vehicleGroups']),
    show: {
      get() {
        return this.visible
      },
      set(value) {
        if (!value) {
          this.selectedVehicleGroup = undefined
          this.newVehicleGroupName = undefined
          this.emailTo = ''
          this.emailBcc = ''
          this.sendingDays = '2, 7'
          this.isMonthlyReportingEnabled = true
          this.setSelectedParkingFineReportingTask(undefined)
          this.$emit('close')
        }
      }
    },
    vehicleGroupsWithNewGroupOption() {
      return [{ name: 'UUS_GRUPP/NEW_GROUP' }, ...this.vehicleGroups]
    }
  },
  watch: {
    vehicleGroups() {
      if (this.vehicleGroups.length) {
        // eslint-disable-next-line prefer-destructuring
        this.selectedVehicleGroup = this.vehicleGroupsWithNewGroupOption[0]
      }
    },
    formValid() {
      if (this.formValid) {
        this.error = undefined
      }
    }
  },
  async mounted() {
    if (!this.selectedParkingFineReportingTask && this.vehicleGroups.length) {
      // eslint-disable-next-line prefer-destructuring
      this.selectedVehicleGroup = this.vehicleGroupsWithNewGroupOption[0]
    }

    if (this.selectedParkingFineReportingTask) {
      const existingGroup = this.vehicleGroups.find(item => {
        return item.ID === this.selectedParkingFineReportingTask.vehicleGroupId
      })
      this.selectedVehicleGroup = existingGroup
      this.emailTo = this.selectedParkingFineReportingTask.emailTo
      this.emailBcc = this.selectedParkingFineReportingTask.emailBcc
      this.sendingDays = this.selectedParkingFineReportingTask.monthlyReportSendingDays
      this.isMonthlyReportingEnabled = this.selectedParkingFineReportingTask.isMonthlyReportingEnabled
    }
  },
  methods: {
    ...mapActions('vehicleGroups', ['getAllVehicleGroups']),
    ...mapActions('enforcement', [
      'postParkingFineReportingTask',
      'putParkingFineReportingTask'
    ]),
    ...mapMutations('enforcement', ['setSelectedParkingFineReportingTask']),
    async onSave() {
      await this.$refs.form.validate()
      if (!this.formValid) return
      if (this.selectedParkingFineReportingTask) {
        await this.putParkingFineReportingTask({
          ID: this.selectedParkingFineReportingTask.ID,
          isMonthlyReportingEnabled: this.isMonthlyReportingEnabled,
          monthlyReportSendingDays: this.sendingDays,
          emailTo: this.emailTo,
          emailBcc: this.emailBcc
        })
        this.$store.commit(
          'app/setSnackbar',
          {
            show: true,
            type: 'success',
            message: this.$vuetify.lang.t(
              '$vuetify.VEHICLE_GROUPS.PUT_SUCCESSFUL'
            )
          },
          { root: true }
        )
      } else {
        const data = {
          isMonthlyReportingEnabled: this.isMonthlyReportingEnabled,
          monthlyReportSendingDays: this.sendingDays,
          emailTo: this.emailTo,
          emailBcc: this.emailBcc
        }
        if (
          (this.selectedVehicleGroup &&
            this.selectedVehicleGroup.name !== 'UUS_GRUPP/NEW_GROUP') ||
          !this.selectedVehicleGroup
        ) {
          data.vehicleGroupId = this.selectedVehicleGroup.ID
        } else {
          data.newVehicleGroupName = this.newVehicleGroupName
        }
        await this.postParkingFineReportingTask(data)
        this.$store.commit(
          'app/setSnackbar',
          {
            show: true,
            type: 'success',
            message: this.$vuetify.lang.t(
              '$vuetify.VEHICLE_GROUPS.POST_SUCCESSFUL'
            )
          },
          { root: true }
        )
      }
      this.show = false
    }
  }
}
</script>
